import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
      }}
    >
      {/* Header */}
      <div
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <Container
          fluid
          style={{
            maxWidth: isMobile ? '100%' : '85%',
            padding: 'clamp(1rem, 3vw, 1.5rem)',
          }}
        >
          <div className='d-flex justify-content-between align-items-center text-white'>
            <Button
              variant='link'
              onClick={() => navigate(-1)}
              className='text-white p-0'
              aria-label='Go back'
            >
              <i className='bi bi-arrow-left fs-4'></i>
            </Button>
            <h5 className='mb-0 fw-bold'>Terms of Service</h5>
            <div style={{ width: '24px' }}></div>
          </div>
        </Container>
      </div>

      {/* Main Content */}
      <Container
        fluid
        style={{
          maxWidth: isMobile ? '100%' : '85%',
          padding: 'clamp(1rem, 3vw, 1.5rem)',
          backgroundColor: '#FFFFFF',
          minHeight: '100vh',
        }}
      >
        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <h5 className='fw-bold mb-3'>Acceptance of Terms</h5>
          <p className='mb-4'>
            By accessing or using our exchange, you agree to be bound by these
            Terms of Service. If you do not agree with any part of these terms,
            you must not use the platform.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Eligibility</h5>
          <p className='mb-4'>
            You must be at least 18 years old and legally permitted under your
            local laws to use cryptocurrency-related services. It is your
            responsibility to ensure compliance with all applicable regulations
            in your jurisdiction.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Use of Services</h5>
          <p className='mb-4'>
            You agree to use the platform only for lawful purposes. You must not
            misuse the platform, attempt unauthorized access, or engage in
            activities that could harm the system or other users.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Risk Disclosure</h5>
          <p className='mb-4'>
            Cryptocurrency markets are highly volatile and involve significant
            risk. Prices can fluctuate rapidly, and losses may occur. You
            acknowledge that you use the platform at your own risk and that we
            are not responsible for financial losses.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Limitation of Liability</h5>
          <p className='mb-4'>
            To the maximum extent permitted by law, we shall not be liable for
            any direct, indirect, incidental, or consequential damages arising
            from the use or inability to use the platform.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Service Availability</h5>
          <p className='mb-4'>
            We strive to provide uninterrupted access to our services but do not
            guarantee continuous availability. Maintenance, updates, or
            technical issues may result in temporary service interruptions.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Changes to Terms</h5>
          <p className='mb-4'>
            We reserve the right to modify these Terms of Service at any time.
            Continued use of the platform after changes constitutes acceptance
            of the updated terms.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default TermsOfService;
